import * as React from "react";
// import DesktopDatePicker from "@material-ui/lab/";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import { useRef, useEffect, useState } from "react";
import { formatDate, parseDate } from "react-day-picker/moment";
import classNames from "classnames";
import styles from "./date-picker.module.scss";
import { Calendar } from "images";
import Image from "../image/image";
import moment from "moment";
import { useMemo } from "react";

const DatePicker = ({
  value,
  onChange,
  name,
  disabled,
  placeholder,
  className,
  disableStartDate,
  disableEndDate,
  hideIcon = false,
}) => {
  const datePickerRef = useRef();
  const [resetKey, setResetKey] = useState(0);

  const MOMENT_FORMAT = "MMMM DD, YYYY";

  useEffect(() => {
    if (!value) {
      setResetKey((k) => k + 1);
    }
  }, [value]);

  const modifiers = useMemo(() => {
    let modifiers = null;
    let disabled = [];
    if (disableStartDate) {
      disabled.push({
        before: new Date(disableStartDate),
      });
    }
    if (disableEndDate) {
      disabled.push({
        after: new Date(disableEndDate),
      });
    }

    if (disabled.length) {
      modifiers = { disabled };
    }
    return modifiers;
  }, [disableStartDate, disableEndDate]);

  return (
    <div
      className={classNames(styles.container, className, {
        [`${styles.disabled}`]: disabled,
      })}
    >
      <div className={styles.datePicker}>
        {disabled ? (
          <div>{value ? moment(value).format(MOMENT_FORMAT) : placeholder}</div>
        ) : (
          <DayPickerInput
            key={resetKey}
            ref={datePickerRef}
            value={value}
            placeholder={placeholder}
            format={MOMENT_FORMAT}
            formatDate={formatDate}
            parseDate={parseDate}
            onDayChange={(date) => {
              if (!disabled) {
                onChange(name, { value: date instanceof Date ? date : null });
              }
            }}
            inputProps={{
              onBlur: () => {
                const inputEl = datePickerRef.current?.getInput();
                if (!inputEl || !inputEl.value.trim()) return;
                const parsed = parseDate(inputEl.value.trim(), MOMENT_FORMAT, "en");
                if (!parsed) {
                  const fallback =
                    disableStartDate && moment(disableStartDate).isAfter(moment())
                      ? new Date(disableStartDate)
                      : new Date();
                  inputEl.value = moment(fallback).format(MOMENT_FORMAT);
                  onChange?.(name, { value: fallback });
                }
              },
            }}
            disabled={disabled}
            dayPickerProps={{
              disabled,
              numberOfMonths: 1,
              modifiers: modifiers,
            }}
          />
        )}
        {!hideIcon && <Image className={styles.icon} src={Calendar} />}
      </div>
    </div>
  );
};

export default DatePicker;
